import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Print = ({
  size,
  type,
  theme,
  className,
  dataTestId = "print-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M12.498 5.21056C11.9907 5.21056 11.5794 5.62183 11.5794 6.12915C11.5794 6.63647 11.9907 7.04773 12.498 7.04773C13.0053 7.04773 13.4166 6.63647 13.4166 6.12915C13.4166 5.62183 13.0053 5.21056 12.498 5.21056Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.875 2.05692V2.62775H14C15.1046 2.62775 16 3.52318 16 4.62775V10.1857C16 11.2902 15.1046 12.1857 14 12.1857H13.0208V13.9463C13.0208 15.0509 12.1254 15.9463 11.0208 15.9463H4.75C3.64543 15.9463 2.75 15.0509 2.75 13.9463V12.1857H2C0.89543 12.1857 0 11.2902 0 10.1857V4.62775C0 3.52318 0.89543 2.62775 2 2.62775H4.125V2.05692C4.125 0.952346 5.02043 0.0569153 6.125 0.0569153H9.875C10.9796 0.0569153 11.875 0.952346 11.875 2.05692ZM5.45833 2.05692C5.45833 1.68873 5.75681 1.39025 6.125 1.39025H9.875C10.2432 1.39025 10.5417 1.68873 10.5417 2.05692V2.62775H5.45833V2.05692ZM14 10.8523H13.0208V10.2721C13.0208 9.16753 12.1254 8.2721 11.0208 8.2721H4.75C3.64543 8.2721 2.75 9.16753 2.75 10.2721V10.8523H2C1.63181 10.8523 1.33333 10.5539 1.33333 10.1857V4.62775C1.33333 4.25956 1.63181 3.96108 2 3.96108H14C14.3682 3.96108 14.6667 4.25956 14.6667 4.62775V10.1857C14.6667 10.5539 14.3682 10.8523 14 10.8523ZM4.08333 10.2721C4.08333 9.90391 4.38181 9.60543 4.75 9.60543H11.0208C11.389 9.60543 11.6875 9.90391 11.6875 10.2721V13.9463C11.6875 14.3145 11.389 14.613 11.0208 14.613H4.75C4.38181 14.613 4.08333 14.3145 4.08333 13.9463V10.2721Z"
    />
  </SVGIcon>
);
